import axios from "@/plugins/axios";

export default {
    findById(approachId) {
        return axios.httpApi.get("/approach-flow/" + approachId);
    },
    save(data) {

        data = JSON.parse(JSON.stringify(data));


        delete data.creditor;
        delete data.approach;
        delete data.updated_at;
        delete data.created_at;
        delete data.strategies;
        delete data.uses;


        if (data.id) {
            return axios.httpApi.patch("/approach-flow/" + data.id, data);
        }
        return axios.httpApi.post("/approach-flow", data);
    },
    update(id, payload) {
        return axios.httpApi.patch("/approach-flow/" + id, payload);
      },
    list(creditor_id, pagination, active = false, nameFilter = null) {
        let params = {}

        if (creditor_id) {
            params.creditor = creditor_id
        }

        if (nameFilter && nameFilter.length > 0) {
            params.text = nameFilter;
        }

        params.active = active;

        params.page = pagination.page;
        params.limit =
            pagination.rowsPerPage == -1 ? 9999 : pagination.rowsPerPage;
        if (pagination.sortBy)
            params.order =
            (pagination.descending ? "-" : "") + pagination.sortBy;

        return axios.httpApi.get("/approach-flow", { params });
    },
    async listAll(creditorId, active = true) {
        let _pagination = {
            rowsPerPage: 500,
            page: 1,
        };
        let result = [];
        let loop = true

        do {
            let res = await this.list(creditorId, _pagination, active)
            result = result.concat(res.objects);
            _pagination.page++;
            if (res.objects.length < _pagination.rowsPerPage) {
                loop = false
                return {
                    objects: result,
                    totalItems: _pagination.totalItems,
                };
            }
        } while (loop);
    },

};